import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/interface-time-hour-glass.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M184 24H72a16 16 0 0 0-16 16v36a16.07 16.07 0 0 0 6.4 12.8l52.27 39.2-52.27 39.2A16.07 16.07 0 0 0 56 180v36a16 16 0 0 0 16 16h112a16 16 0 0 0 16-16v-35.64a16.09 16.09 0 0 0-6.35-12.77L141.27 128l52.38-39.6A16.05 16.05 0 0 0 200 75.64V40a16 16 0 0 0-16-16m0 16v16H72V40Zm0 176H72v-36l56-42 56 42.35Zm-56-98L72 76v-4h112v3.64Z" }, null, -1)])]);
}
var interface_time_hour_glass_default = { render };
//#endregion
export { interface_time_hour_glass_default as default, render };

//# sourceMappingURL=interface-time-hour-glass.svg.js.map